export enum CarUser {
  CarOwner = 'CarOwner',
  CarLeaser = 'CarLeaser',
}
